var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKakaoGiftinline = function SvgKakaoGiftinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 13.24V8.44a1.201 1.201 0 00-.6-1.038l-4.2-2.4a1.197 1.197 0 00-1.2 0l-1.151.658L2.399 7.4a1.203 1.203 0 00-.6 1.039v4.8a1.201 1.201 0 00.6 1.039l4.2 2.4a1.197 1.197 0 001.2 0l4.2-2.4a1.203 1.203 0 00.6-1.039z",
    stroke: "#fff",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.962 7.816l5.238 3.03 5.238-3.03",
    stroke: "#fff",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 16.84v-6",
    stroke: "#fff",
    strokeWidth: 1.165,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.312 1.724a1.925 1.925 0 00-2.722 0l-.372.371-.37-.37a1.925 1.925 0 10-2.723 2.722l.37.371 2.723 2.723 2.723-2.723.37-.37a1.925 1.925 0 00.001-2.724z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.092,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.492 11.087l4.768-2.792.016.289-.014 5.168-4.783 2.716",
    fill: "#fff"
  })));
};

export default SvgKakaoGiftinline;